// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6013f2d3","703":"d781947e","787":"3b3e54b0"}[chunkId] + ".chunk.js";
};